module.exports = __webpack_public_path__ + "static/malar-symbol-SCAG-9a8e360aae4140d309dfdc9f232b1a12.png";